import './file-input.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FileInput extends React.Component {

  render() {
    const id = `file-input-${Math.random().toString().replace(/\./, '')}`;
    const { onChange, children, ...rest } = this.props;
    return (
      <label className="file-input" htmlFor={id} onClick={() => this.ref.click()}>
        <input
          type="file"
          onChange={async function(event) {
            await onChange(event);
            event.target.value = null;
          }}
          name={id}
          id={id}
          ref={ref => this.ref = ref}
          {...rest}
        />
        {children}
      </label>
    )
  }

}

FileInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  accept: PropTypes.any,
  multiple: PropTypes.any,
  required: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/file-input/index.js